import { PropsWithClassName } from "../../../../models/props-with-class-name";
import ProgressiveImg from "../../../Shared/ProgressiveImg/ProgressiveImg";
import styles from "./GraphImg.module.css";
import svgImg from "../../../../assets/ecgs/svgTest.svg";

type GraphImgProps = {
  src?: string;
  placeholder?: string;
};

const GraphImg = ({
  src,
  placeholder,
  className,
}: PropsWithClassName<GraphImgProps>) => (
  <div className={`${styles.imgWrapper} ${className ?? ""}`}>
    <ProgressiveImg
      className="img-fluid"
      // src={svgImg}
      src={`data:image/png;base64, ${src}`}
      placeholderSrc={placeholder ?? ""}
    />
  </div>
);

export default GraphImg;
